// extracted by mini-css-extract-plugin
export default {"box":"Footer_box__shvR7","socialLinks":"Footer_socialLinks__mNZA4"};